import styled from '@emotion/styled'

export const NoLabel = styled.p`
  font-size: 14px;
  text-align: center;
`
